// Checkout configuration
// Replace with your actual LemonSqueezy checkout URL
export const LEMONSQUEEZY_CHECKOUT_URL = 'https://checkout.lemonsqueezy.com/your-checkout-id'

// Alternative: If using Wasp actions for checkout
// export const FOUNDING_MEMBER_PLAN = 'founder_monthly_20'